import {BIcon} from "bootstrap-vue";

export default {
    menuitems: (state) => state.menuitems,
    visibleitems: (state, getters, rootState, rootGetters) => {
        return state.menuitems.filter((el) => {
            if (el.meta && el.meta.icon) {
                return rootGetters["auth/test_permissions"](el.meta.require);
            }
            return false;
        }).map((mn) => {
            return {
                href: mn.path,
                exactPath: true,
                title: mn.meta.title,
                icon: {
                    element: BIcon,
                    attributes: {
                        icon: mn.meta.icon,
                    },
                },
            };
        });
    },
};
